/**
 * KellyGirl Shopify Theme — Main JavaScript
 */

document.addEventListener('DOMContentLoaded', function () {

  // ============================================================
  // CART OVERLAY
  // ============================================================

  const cartOverlay = document.getElementById('cart-overlay');
  const closeCartBtn = document.getElementById('close-cart');
  const cartButton = document.getElementById('cart-button');
  const cartCountBadge = document.getElementById('cart-count');
  const cartItemsContainer = document.getElementById('cart-items-container');
  const bundleDealBanner = document.getElementById('bundle-deal');
  const cartTotalSection = document.getElementById('cart-total-section');

  function openCart() {
    if (!cartOverlay) return;
    refreshCart();
    cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartOverlay) return;
    cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (cartButton) cartButton.addEventListener('click', openCart);
  if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);

  if (cartOverlay) {
    cartOverlay.addEventListener('click', function (e) {
      if (e.target === cartOverlay) closeCart();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  // ============================================================
  // CART API HELPERS
  // ============================================================

  function formatMoney(cents) {
    const dollars = cents / 100;
    return '$' + (dollars % 1 === 0 ? dollars.toString() : dollars.toFixed(2));
  }

  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      return await res.json();
    } catch (e) {
      return { items: [], item_count: 0, total_price: 0 };
    }
  }

  async function updateCartCount() {
    const cart = await fetchCart();
    if (cartCountBadge) {
      cartCountBadge.textContent = cart.item_count;
      cartCountBadge.classList.toggle('hidden', cart.item_count === 0);
    }
  }

  async function refreshCart() {
    const cart = await fetchCart();
    renderCart(cart);
  }

  function renderCart(cart) {
    if (!cartItemsContainer) return;

    if (cart.item_count === 0) {
      cartItemsContainer.innerHTML = `
        <div class="empty-cart">
          <h3>Your cart is empty</h3>
          <p>Add some hats to get started!</p>
        </div>
      `;
      if (bundleDealBanner) bundleDealBanner.style.display = 'none';
      if (cartTotalSection) cartTotalSection.style.display = 'none';
      return;
    }

    let html = '';
    cart.items.forEach(function (item) {
      const variantLine = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="cart-item-colorway">${item.variant_title}</p>`
        : '';
      const qtyLine = item.quantity > 1
        ? `<p class="cart-item-qty">Qty: ${item.quantity}</p>`
        : '';
      const imgTag = item.image
        ? `<img class="cart-item-image" src="${item.image}" alt="${item.product_title}" loading="lazy">`
        : '';

      html += `
        <div class="cart-item" data-key="${item.key}">
          ${imgTag}
          <div class="cart-item-info">
            <h3>${item.product_title}</h3>
            ${variantLine}
            <p class="cart-item-price">${formatMoney(item.final_line_price)}</p>
            ${qtyLine}
          </div>
          <button class="remove-item" data-key="${item.key}" aria-label="Remove ${item.product_title}">Remove</button>
        </div>
      `;
    });

    cartItemsContainer.innerHTML = html;

    // Bind remove buttons
    cartItemsContainer.querySelectorAll('.remove-item').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeCartItem(this.dataset.key);
      });
    });

    // Bundle deal banner (2+ items)
    if (bundleDealBanner) {
      bundleDealBanner.style.display = cart.item_count >= 2 ? 'block' : 'none';
    }

    // Total
    if (cartTotalSection) {
      cartTotalSection.style.display = 'block';
      const totalEl = document.getElementById('cart-total-amount');
      if (totalEl) {
        totalEl.textContent = 'Total: ' + formatMoney(cart.total_price);
      }
    }
  }

  async function removeCartItem(key) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      await updateCartCount();
      await refreshCart();
    } catch (e) {
      console.error('Error removing item:', e);
    }
  }

  // ============================================================
  // ADD TO CART — Product grid cards (data-variant-id buttons)
  // ============================================================

  async function addToCart(variantId, btn) {
    const original = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      });

      if (res.ok) {
        btn.textContent = 'Added!';
        await updateCartCount();
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
          openCart();
        }, 800);
      } else {
        const err = await res.json();
        btn.textContent = err.description || 'Try again';
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 2500);
      }
    } catch (e) {
      btn.textContent = 'Error';
      setTimeout(function () {
        btn.textContent = original;
        btn.disabled = false;
      }, 2500);
    }
  }

  // Bind add-to-cart buttons not inside a <form> (collection/homepage cards)
  document.querySelectorAll('.add-to-cart-btn[data-variant-id]').forEach(function (btn) {
    if (btn.closest('form')) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      addToCart(this.dataset.variantId, this);
    });
  });

  // ============================================================
  // PRODUCT PAGE — AJAX form submit
  // ============================================================

  const productForm = document.querySelector('.product-form');
  if (productForm) {
    productForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      const formData = new FormData(this);
      const variantId = formData.get('id');
      const submitBtn = this.querySelector('[type="submit"]');
      if (!variantId || !submitBtn) return;

      await addToCart(variantId, submitBtn);
    });
  }

  // ============================================================
  // VARIANT SELECTOR — Product page
  // ============================================================

  const variantSelect = document.getElementById('variant-select');
  if (variantSelect) {
    let variants = [];
    try {
      variants = JSON.parse(variantSelect.dataset.productVariants || '[]');
    } catch (e) {}

    variantSelect.addEventListener('change', function () {
      const selectedId = parseInt(this.value, 10);
      const variant = variants.find(function (v) { return v.id === selectedId; });
      if (!variant) return;

      // Update price
      const priceEl = document.getElementById('product-price');
      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      // Update colorway label
      const colorwayEl = document.getElementById('selected-colorway');
      if (colorwayEl && variant.title !== 'Default Title') {
        colorwayEl.textContent = variant.title;
      }

      // Update hidden form input
      const hiddenInput = productForm && productForm.querySelector('input[name="id"]');
      if (hiddenInput) hiddenInput.value = variant.id;

      // Update submit button
      const addBtn = document.querySelector('.product-page-details .add-to-cart-btn');
      if (addBtn) {
        addBtn.dataset.variantId = variant.id;
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }

      // Update main image if variant has its own image
      if (variant.featured_image && variant.featured_image.src) {
        const mainImg = document.getElementById('product-main-image');
        if (mainImg) mainImg.src = variant.featured_image.src;
      }
    });
  }

  // ============================================================
  // THUMBNAIL GALLERY — Product page
  // ============================================================

  document.querySelectorAll('.thumbnail-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const mainImg = document.getElementById('product-main-image');
      if (mainImg && this.dataset.imageUrl) {
        mainImg.src = this.dataset.imageUrl;
      }
      // Active state
      document.querySelectorAll('.thumbnail-btn').forEach(function (b) {
        b.classList.remove('active');
      });
      this.classList.add('active');
    });
  });

  // ============================================================
  // SMOOTH SCROLL — Anchor and data-scroll-to links
  // ============================================================

  function smoothScrollTo(selector) {
    const target = document.querySelector(selector);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }

  document.querySelectorAll('[data-scroll-to]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      smoothScrollTo(this.dataset.scrollTo);
    });
  });

  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      const hash = this.getAttribute('href');
      if (hash.length > 1) {
        e.preventDefault();
        smoothScrollTo(hash);
      }
    });
  });

  // ============================================================
  // INIT
  // ============================================================

  updateCartCount();

});
